import { createContext, useContext } from 'react';

const WorldwideContext = createContext({ isWorldwide: false });

export const WorldwideProvider = ({ children, isWorldwide = false }) => (
  <WorldwideContext.Provider value={{ isWorldwide }}>
    {children}
  </WorldwideContext.Provider>
);

export const useWorldwide = () => useContext(WorldwideContext);

// Features hidden for worldwide users
// Amendment 2026-04-16 (WW Batch A): hide checklist/performance/education/achievements
// Amendment 2026-04-17: hide feedback tab for WW users
export const WORLDWIDE_HIDDEN_TABS = [
  'journal', 'ai', 'tools', 'guardian',
  'checklist', 'performance', 'education', 'achievements',
  'feedback',
];

// Fira Worldwide logo asset (amendment 2026-04-17 — circular "Fira worldwide" mark)
export const FIRA_WW_LOGO = 'https://customer-assets.emergentagent.com/job_98679286-631c-4c8b-86e3-cc07640152dd/artifacts/uwre8p1w_IMG_5360.jpeg';

export default WorldwideContext;
